import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const { user } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token || !user) return;

    const s = io('/', { auth: { token } });

    s.on('connect', () => {
      console.log('Socket connected:', s.id);
    });

    s.on('connect_error', (err) => {
      console.error('Socket connection error:', err.message);
    });

    // When server tells us to join a newly created channel room
    s.on('joined_channel', ({ channel_id }) => {
      s.emit('join_channel', { channelId: channel_id });
    });

    setSocket(s);
    return () => {
      s.disconnect();
      setSocket(null);
    };
  }, [user]);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}

export const useSocket = () => useContext(SocketContext);
